const svgIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <path d="M5.5 5V19.5H20" stroke="#121923" stroke-width="1.2"/>
  <path d="M7.5 16L11.5 11.5L15.5 14L19.5 8.5" stroke="#121923" stroke-width="1.2"/>
</svg>`;
const firstSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <path d="M5.5 5V19.5H20" stroke="#121923" stroke-width="1.2"/>
  <path d="M7.5 16L11.5 11.5L15.5 14L19.5 8.5" stroke="#121923" stroke-width="1.2"/>
  <path d="M7.5 6L10.5 10L13.5 8L19.5 14" stroke="#1c8adb" stroke-width="1.2"/>
</svg>`;
export const uiRender = (arg) => {
    const { schema, rootElement, options } = arg;
    const measurementPoints = options.measurementPoints;
    // Set the root element styles
    rootElement.style.position = 'relative';
    rootElement.style.width = '100%';
    rootElement.style.height = '100%';
    rootElement.style.display = 'flex';
    rootElement.style.flexWrap = 'wrap';
    rootElement.style.justifyContent = 'flex-start';
    rootElement.style.alignItems = 'flex-start';
    const measurementPointID = Number(schema.appRender.measurementPoint);
    const measurementPoint = (measurementPoints).find((point) => point.id === measurementPointID);
    if (measurementPoints.length === 0 || !measurementPoints) {
        const error = document.createElement('p');
        error.innerHTML = 'No measurement points available';
        error.style.flex = "1";
        error.style.textAlign = 'center';
        error.style.color = '#ff0000';
        error.style.fontSize = '16px';
        error.style.marginTop = '20px';
        rootElement.appendChild(error);
    }
    else if (!measurementPoint) {
        const error = document.createElement('p');
        error.innerHTML = 'No measurement point selected';
        error.style.flex = "1";
        error.style.textAlign = 'center';
        error.style.color = '#ff0000';
        error.style.fontSize = '16px';
        error.style.marginTop = '20px';
        rootElement.appendChild(error);
    }
    else {
        const measurements = measurementPoint?.measurements;
        const numRows = Math.ceil((measurements.length + 1) / 2); // Include firstSvg in the count
        const containerHeight = rootElement.clientHeight; // Height of the container
        const rowHeight = containerHeight / numRows;
        // Create and append the firstSvg
        const firstChart = document.createElement('div');
        firstChart.style.flex = `1 1 calc(50% - 10px)`; // Each chart takes up 50% of the width minus the gap
        firstChart.style.height = `${rowHeight}px`; // Set the height based on the number of rows
        firstChart.style.alignSelf = "flex-start"; // Align the first element of each row to the left
        firstChart.innerHTML = firstSvg;
        rootElement.appendChild(firstChart);
        for (let i = 0; i < measurements.length; i++) {
            const chart = document.createElement('div');
            chart.style.flex = `1 1 calc(50% - 10px)`; // Each chart takes up 50% of the width minus the gap
            chart.style.height = `${rowHeight}px`; // Set the height based on the number of rows
            chart.style.alignSelf = "flex-start"; // Align the first element of each row to the left
            chart.innerHTML = svgIcon;
            rootElement.appendChild(chart);
        }
    }
};
//# sourceMappingURL=uiRender.js.map